import { ExportInterfaceConfigurationTransferType } from 'src/app/base/models/models.swagger.generated';
import { ExportInterfaceConfigurationDTO, ExportInterfaceConfigurationType } from '../../../../base/models/models.swagger.generated';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { ConfigurationsService } from '../../configurations/configurations.service';
import { ConfigurationFormCoordinatorService } from '../configuration-forms/configuration-form-coordinator.service';
import { ModalService } from '../../../../base/shared/modal/modal.service';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-configuration-overview',
    templateUrl: './configuration-overview.component.html',
    styleUrls: ['./configuration-overview.component.scss'],
    imports: [
        GridModule,
        QueryBuilderModule,
        TranslateModule,
    ]
})

export class ConfigurationOverviewComponent extends GridBaseComponent<any> implements OnInit {
  @Output() rowSelected = new EventEmitter<any>();

  @Input() public set selectedConfigId(value: number) {
    if (value !== this._selectedConfigId) {
      this._selectedConfigId = value;
      if (value !== null && value !== undefined) {
        this.grid?.selectRows([this.grid.getRowIndexByPrimaryKey(value)]);
      } else {
        this.grid?.selectRows([]);
      }
    }
  }

  private addedRecordId: number = null;
  private previousRowIndex: number;
  private _selectedConfigId: number;

  constructor(
    translateService: TranslateService,
    protected configurationsService: ConfigurationsService,
    private configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
  ) {
    super(translateService, configurationsService);
    this.addIndexFindColumnName = 'id';
  }

  ngOnInit() {
    this.isActiveColumnName = 'Active';
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.configurationsService, this.spinnerService),
    });

    this.configurationsService.oneTimeFilterConfigId = this._selectedConfigId;
  }

  public recordAdded(id: number) {
    this.addedRecordId = id;
    this.grid.refresh();
  }

  public onDataBound() {
    if (this.addedRecordId) {
      const index = this.grid?.getRowIndexByPrimaryKey(this.addedRecordId);
      this.grid?.selectRow(index);
      this.addedRecordId = null;
      if(this.previousRowIndex >= index) {
        this.previousRowIndex += 1;
      }
    }

    if (this._selectedConfigId && this.grid?.selectedRowIndex < 0) {
      const index = this.grid?.getRowIndexByPrimaryKey(this._selectedConfigId);
      this.grid?.selectRow(index);
    }
  }

  public refresh(): void {
    this.grid.refresh();
  }

  public getTypeName(type: number): string {
    return 'i18n.shared.configurationTypes.' + ExportInterfaceConfigurationType[type];
  }

  public getTransferTypeName(transferType: number): string {
    return 'i18n.shared.transferTypes.' + ExportInterfaceConfigurationTransferType[transferType];
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    if (this.configurationFormCoordinatorService.isFormDirty()) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.discard-dialog.title', 'i18n.domain.export-configuration.configurations.discard-dialog.question');
      dialog.onOkSubject.subscribe(() => {
        const data = args.data as ExportInterfaceConfigurationDTO;
        if (data) {
          this._selectedConfigId = data.id;
          this.rowSelected.emit(data);
          this.previousRowIndex = this.grid?.selectedRowIndex;
        }
      });
      dialog.onCancelSubject.subscribe(() => {
        this.grid.selectRows([this.previousRowIndex]);
      });
    } else {
      const data = args.data as ExportInterfaceConfigurationDTO;
      if (data) {
        this._selectedConfigId = data.id;
        this.rowSelected.emit(data);
        this.previousRowIndex = this.grid?.selectedRowIndex;
      }
    }
  }

  public resetRowSelected(): void {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid.selectRows([]);
    }
  }

  protected initializeEditForm(data: ExportInterfaceConfigurationDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

}
